export const PHOTO_CONFIG = {
  ASPECT_RATIO: 16 / 9,
  MIN_HEIGHT: 1280,
  MIN_WIDTH: 1920,
  MAX_HEIGHT: 4500,
  MAX_WIDTH: 4500,
};
